import { render } from "./InventoryDetails.vue?vue&type=template&id=15c0b80e"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__